// InviteDetails.jsx
import React  from 'react';
import { useState ,useEffect} from 'react';
import { Box,Button,Typography, Avatar, MenuItem,
  Select, } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import invited from '../../../../assets/Dashboard/invited.svg';
import { useSelector } from "react-redux";
// import novacore from '../../../assets/novacore.png';
import profileperson from '../../../../assets/profileperson.png';
import back from "../../../../assets/back.svg"
import CustomText, { textStyles } from '../../../../components/CustomText';
import trial from "../../../../assets/Dashboard/trial.svg";
import company from "../../../../assets/company.png";
import code from "../../../../assets/code.svg";
import CustomButton from "../../../../components/CustomButton";
import active from "../../../../assets/Dashboard/active.svg";
import request from "../../../../assets/Dashboard/request.svg";
import clienttrial from "../../../../assets/Dashboard/clienttrial.svg";
import inactive from '../../../../assets/Dashboard/inactive.svg';
import process from "../../../../assets/Dashboard/process.svg";
import overdue from "../../../../assets/Dashboard/overdue.svg";
import received from "../../../../assets/Wallet/received.svg";
import pending from "../../../../assets/Wallet/pending.svg";
import dashboardlogo1 from "../../../../assets/Dashboard/dashboardlogo1.svg";
import dashboardlogo2 from "../../../../assets/Dashboard/dashboardlogo2.svg";
import dashboardlogo3 from "../../../../assets/Dashboard/dashboardlogo3.svg";
import dashboardlogo4 from "../../../../assets/Dashboard/dashboardlogo4.svg";
import dashboardlogo5 from "../../../../assets/Dashboard/dashboardlogo5.svg";
import DashboardCard from '../../../../components/Cards/DashboardCard';
import ActiveDetailsTable from './ActiveDetailsTable';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { decryptToken } from "../../../../Utlis/Encryption";
import CircularProgress from '@mui/material/CircularProgress';
import {toast,Toaster} from "react-hot-toast";
import { BASE_URL } from '../../../../components/BaseUrl';
import MatricGraph from './Matricgraph';
import StatusDropdown from '../../../../components/StatusDropdown';
import dollarsign from "../../../../assets/Dashboard/dollarsign.svg"; 
import dummy from "../../../../assets/dummy.png";
import { formatNumber } from "../../../../Utlis/formatNumber";
import imageIcon from "../../../../assets/imageIcon.png";
import document1 from "../../../../assets/document1.svg";
import { convertUTCToLocalDateTime } from "../../../../components/dateTime";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts';
const textStyle = {
  label: { fontWeight: 500, fontSize: 13.5, color: '#344054', lineHeight: '28px' },
  value: { fontWeight: 600, fontSize: 13.5, color: '#101828', lineHeight: '28px' },
};


const ActiveDetails= ({ selectedRow, onClose }) => {
    const [selectedYear, setSelectedYear] = useState('2025');
      const isMobile = useMediaQuery('(max-width:768px)');
        const execIdFromRedux = useSelector((s) => s.auth?.user?.id); // <-- replace with your real path
  const executiveId = execIdFromRedux
      const navigate=useNavigate()
      const { t } = useTranslation();
          const [updatingTo, setUpdatingTo] = React.useState("");
            const [isUpdatingStatus, setIsUpdatingStatus] = React.useState(false);

  const rawEncryptedToken = localStorage.getItem("token");

const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

const [profileImgSrc, setProfileImgSrc] = React.useState(dummy);
const [companyLogoSrc, setCompanyLogoSrc] = React.useState(dummy);

const loadImageAsBlob = async (url, fallback, setter) => {
  if (!url) {
    setter(fallback);
    return;
  }
  try {
    const res = await fetch(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error("Image fetch failed");
    const blob = await res.blob();
    const objectURL = URL.createObjectURL(blob);
    setter(objectURL);
  } catch (err) {
    console.error("Image load error:", err);
    setter(fallback);
  }
};
React.useEffect(() => {
  if (!selectedRow) return;

  // ✅ use correct fields
  loadImageAsBlob(
    selectedRow.account_details?.profile_image,
    dummy,
    setProfileImgSrc
  );
  loadImageAsBlob(
    selectedRow.company_details?.company_logo,
    dummy,
    setCompanyLogoSrc
  );
}, [selectedRow, token]);




const getFileName = (url) => {
  if (!url) return "";
  return url.split("/").pop();
};

// Check if the URL is image or PDF
const getFileType = (url) => {
  if (!url) return null;
  const lower = url.toLowerCase();
  if (lower.endsWith(".pdf")) return "pdf";
  if (lower.endsWith(".jpg") || lower.endsWith(".jpeg") || lower.endsWith(".png")) return "image";
  return "other";
};


const statusIcons = {
  Active: active,
  Trial: trial,
  Invited: invited,
  Inactive: inactive,
  Requested: request,
  Overdue:overdue,
   Processing:process,
   Paid:active,
   Pending:pending,
    Received:received

};

const statusStyles = {
  Active: { backgroundColor: '#4BCE97', color: '#164B35' },
  Trial: { backgroundColor: '#FEA362', color: '#702E00' },
  Invited: { backgroundColor: '#579DFF', color: '#09326C' },
  Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
    Paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
  Processing: { backgroundColor: '#FDD35C', color: '#7A4100' },
  Overdue: {backgroundColor: '#FFA26B', color: '#722800' },
   Pending: {  backgroundColor: '#F5CD47',  color: '#533F04', },
    Received: {  backgroundColor: '#4BCE97', color: '#164B35',  }
};
const rawStatus = selectedRow.status || selectedRow.account_details?.status || "Pending";
const statusKey = rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1); // e.g., "invited" → "Invited"
const statusStyle = statusStyles[statusKey] || { backgroundColor: "#eee", color: "#333" };
const statusIcon = statusIcons[statusKey];

const subscriptionStatusIcons = {
  Active: active,
  Trial: trial,
  Invited: invited,
  Inactive: inactive,
  Requested: request,
  Overdue: overdue,
  Processing: process,
  Paid: active,
  Pending: pending,
  Received: received,
};

const subscriptionStatusStyles = {
  Active: { backgroundColor: '#4BCE97', color: '#164B35' },
  Trial: { backgroundColor: '#FEA362', color: '#702E00' },
  Invited: { backgroundColor: '#579DFF', color: '#09326C' },
  Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
  Paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
  Processing: { backgroundColor: '#FDD35C', color: '#7A4100' },
  Overdue: { backgroundColor: '#FFA26B', color: '#722800' },
  Pending: { backgroundColor: '#F5CD47', color: '#533F04' },
  Received: { backgroundColor: '#4BCE97', color: '#164B35' },
};

const rawSubscriptionStatus = selectedRow.subscription_details?.subscription_status || 'Trial';
const subscriptionStatusKey = rawSubscriptionStatus.charAt(0).toUpperCase() + rawSubscriptionStatus.slice(1);
const subscriptionStatusStyle = subscriptionStatusStyles[subscriptionStatusKey] || { backgroundColor: '#eee', color: '#333' };
const subscriptionStatusIcon = subscriptionStatusIcons[subscriptionStatusKey];
// console.log("selectedRow.company_details:", selectedRow?.company_details);

  const [stats, setStats] = useState(null)
  useEffect(() => {
    if (!executiveId || !token) return;

    fetch(`${BASE_URL}/account-executive/${executiveId}/statistics/dashboard`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
          console.log("AE Dashboard API Response:", res); 
        if (!res.error) {
          setStats(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching dashboard stats:", err);
      });
  }, [executiveId, token]);
const formatSubscription = (value) => {
  if (!value) return "";

  return value
    .replace(/_/g, " ")      // full_monthly → full monthly
    .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize each word
};

const formatDateTime = (date) => {
  if (!date) return "-";
  return convertUTCToLocalDateTime(date);
};


const formatAdminType = (value) => {
  if (!value) return "-";

  return value
    .split("_")                 // ["legal", "entity"]
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))  
    .join(" ");                // "Legal Entity"
};
const formatDOB = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });
};

    if (!selectedRow) return null;
  return (
    <>
      <Box
        sx={{
          border: '1px solid #E4E6EF',
          borderRadius: 2,
          px: 2,
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          minHeight: 55,
        }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
          onClick={onClose}
        >
          <img src={back} style={{width:30,height:30}} />
          <CustomText
            sx={{ ...textStyles.h1, fontWeight: 500, fontSize: '14px', color: '#626F86', textAlign: 'center' }}
          >
         {t('activeDetails.back')}  /  {selectedRow.company_details.legal_name}
          </CustomText>
        </Box>
      </Box>

         <Box sx={{
        display: 'grid',
        gap: 2,
        mt:2,
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
          lg: 'repeat(5, 1fr)',
        },
      }}>
        <DashboardCard icon={dashboardlogo1} title={t('activeDetails.dashboardCards.clients')} 
          description={stats ? formatNumber(stats.companies.total) : "..."}
          onClick={() => navigate('/invited-clients' , { state: { fromDashboard: true } })} />
        <DashboardCard icon={dollarsign} title={t('total_earned')}   description={stats ? formatNumber(stats.commissions.total_earned,true ): "..."}
               onClick={() => navigate('/my-wallet' , { state: { fromDashboard: true } })}/>
        <DashboardCard icon={dashboardlogo3} title={t('Received Earnings')} description={stats ? formatNumber(stats.commissions.paid,true ): "..."}
                 onClick={() => navigate('/my-wallet' , { state: { fromDashboard: true } })} />
        <DashboardCard icon={dashboardlogo4}  title={t('Recent Signups')} description={stats ? formatNumber(stats.companies.recent_30_days) : "..."}
          onClick={() => navigate('/invited-clients' , { state: { fromDashboard: true } })} />
        <DashboardCard icon={dashboardlogo5} title={t('Pending Earnings')} description={stats ?formatNumber(stats.commissions.pending,true) : "..."} 
       onClick={() => navigate('/clients-requests' , { state: { fromDashboard: true } })} />
      </Box>

      <Box sx={{ display: 'flex',flexDirection:isMobile?"column":"row", gap: 2, mt: 2, }}>
        <Box sx={{ width: isMobile?"100%":'50%',}}>
        {/* Left Panel */}
        <Box
          sx={{
          
            backgroundColor: '#fff',
            borderRadius: 2,
            border: '1px solid #E4E6EF',
            p: 3,
          }}
        >
          <CustomText sx={{ ...textStyles.h1, fontSize: 18, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
   {t('activeDetails.accountDetails')}
          </CustomText>

          {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
            <img src={selectedRow.image || profileperson} alt="profile" style={{ width:120, height:120, borderRadius: '50%' }} />
          </Box> */}

           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
                      <img 
                   
                         src={profileImgSrc || dummy}
                       alt="profile" style={{ width:140, height:140, borderRadius: '50%' }} />
                    </Box>


          <Box>

      <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
     {t('activeDetails.id')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
          {selectedRow.account_details.id}  </CustomText>  </Box>

    
   
                                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                          <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                       {t('activeDetails.status')}
                          </CustomText>
                     
                             <Box sx={{ pointerEvents: "none" }}>
      <StatusDropdown
      currentStatus={selectedRow.account_details.status || "pending"}
      />
    </Box>
                        </Box>

   <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
        {t('activeDetails.registeredOn')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right" }}>
       {formatDateTime(selectedRow.account_details.registered_on)} </CustomText>  </Box>
          
   <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
          {t('activeDetails.companyAdmin')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right"  }}>
      {selectedRow.account_details.company_admin} </CustomText>  </Box>
<Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center", mb:2}}>
  <CustomText 
    sx={{ 
      ...textStyles.h1, 
      fontSize:16, 
      fontWeight: 400, 
      color: "#5E5C5C",
      textAlign:"left" 
    }}
  >
    {t("InviteDetails.dob")}
  </CustomText>

  <CustomText 
    sx={{ 
      ...textStyles.h1, 
      fontSize:15, 
      fontWeight: 400, 
      color: "#172B4D",
      textAlign:"left" 
    }}
  >
    {formatDOB(selectedRow.account_details.dob)}
  </CustomText>
</Box>
           <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
    {t('activeDetails.registeredEmail')}
</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
      {selectedRow.account_details.registered_email} </CustomText>  </Box>

             <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
   {t('activeDetails.phone')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
       {selectedRow.account_details.phone_no} </CustomText>  </Box>

           
          </Box>

     
      

      
     
        </Box>

        {/* <MatricGraph  companyId={selectedRow?.account_details?.id}/> */}
        
          </Box>

        <Box
          sx={{
           width: isMobile?"100%":'50%',
            backgroundColor: '#fff',
            borderRadius: 2,
            border: '1px solid #E4E6EF',
            p: 3,
          }}
        >
       
     <CustomText sx={{ ...textStyles.h1, fontSize: 18, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
       {t('activeDetails.companyDetails')}
          </CustomText>

          {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
            <img src={company} alt="profile" style={{ width:120, height:120, borderRadius: '50%' }} />
          </Box> */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
                      <img 
                     src={companyLogoSrc || dummy}
                       alt="profile" style={{ width:140, height:140, borderRadius: '50%' }} />
                    </Box>
                    
           <CustomText sx={{ ...textStyles.h1, fontSize: 16, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
    {t('activeDetails.legalDetails')}
          </CustomText>


   <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"right" }}>
{t('activeDetails.workspaceCode')}</CustomText>
      {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box component="img" src={code} alt="code icon" sx={{ width: 20, height: 20 }} />
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left"
                }}
              >
              {selectedRow.company_details.workspace_code}
              </CustomText>
            </Box>   */}
                  <Box
  sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}
   onClick={() => {
    const code = selectedRow?.company_details?.workspace_code;
    if (code) {
      navigator.clipboard.writeText(code);
      toast.success(t("copyCodeSuccess"));
    }
  }}
>
  <Box
    component="img"
    src={code}
    alt="code icon"
    sx={{ width: 20, height: 20 }}
  />

  <CustomText
    sx={{
      ...textStyles.h1,
      fontSize: 15,
      fontWeight: 400,
      color: "#172B4D",
      textAlign:"right" ,
      userSelect: "text"    // allows direct highlight + copy
    }}
  >
    { selectedRow?.company_details?.workspace_code}
  </CustomText>
</Box>
            </Box>
        
        
       <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('activeDetails.legalName')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
 {selectedRow.company_details.legal_name}</CustomText>  </Box>
          <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('activeDetails.industry')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow.company_details.business_sector_industry}</CustomText>  </Box>

          <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('activeDetails.tradeNo')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow.company_details.trade_no}</CustomText>  </Box>
         
     <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('activeDetails.registrationNo')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow.company_details.business_registration_no}</CustomText>  </Box>
        <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('activeDetails.businessEmail')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow.company_details.business_email}</CustomText>  </Box>

       <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('activeDetails.businessPhone')}
</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow.company_details.business_phone_no}</CustomText>  </Box>


      

             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C" }}>
    {t("inviteDetailsExtra.businessActivity")}
  </CustomText>
  <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D" }}>
    {selectedRow.company_details.business_activity || "-"}
  </CustomText>
</Box>
<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C" }}>
  {t("inviteDetailsExtra.primaryColor")}
  </CustomText>

  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Box sx={{ width: 20, height: 20, borderRadius: "4px", bgcolor: selectedRow.company_details.primary_color }} />
    <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>{selectedRow.company_details.primary_color}</CustomText>
  </Box>
</Box>
<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C" }}>
  {t("inviteDetailsExtra.secondaryColor")}
  </CustomText>

  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Box sx={{ width: 20, height: 20, borderRadius: "4px", bgcolor: selectedRow.company_details.secondary_color }} />
    <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>{selectedRow.company_details.secondary_color}</CustomText>
  </Box>
</Box>
<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
 <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
  {t("inviteDetailsExtra.administratorType")}
  </CustomText>
  <CustomText sx={{ fontSize: 15, color: "#172B4D" }}>
    {formatAdminType(selectedRow.account_details.administrator_type)}

  </CustomText>
</Box>


<CustomText
        sx={{
          ...textStyles.h1,
          fontSize: 16,
          mb: 1,
          mt: 3,
          fontWeight: 600,
          color: "#003149",
          textAlign: "left",
        }}
      >
        {t("inviteDetailsExtra.adminDocument")}
      </CustomText>
      
      <Box
        sx={{
          border: "1px solid #E4E6EF",
          p: 2,
          borderRadius: 2,
          display: "flex",
          flexWrap: "wrap", 
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* LEFT SIDE ICON + FILE NAME */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={
              getFileType(selectedRow.company_details.admin_document_url) === "pdf"
                ? document1
                : imageIcon
            }
            style={{ width: 28, height: 28 }}
          />
      
          <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>
            {getFileName(selectedRow.company_details.admin_document_url)}
          </CustomText>
        </Box>
      
        {/* RIGHT SIDE VIEW BUTTON */}
        <Button
          variant="outlined"
          sx={{ textTransform: "none", fontSize: 12, borderRadius: "6px" }}
          onClick={() =>
            window.open(selectedRow.company_details.admin_document_url, "_blank")
          }
        >
          {t("inviteDetailsExtra.viewDocument")}
        </Button>
      </Box>
          <Box mt={2}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 18, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
  {t('activeDetails.addressDetails')}
          </CustomText>
           <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
    {t('activeDetails.country')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
 {selectedRow.company_address_details.country}</CustomText>  </Box>
           
           <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
  {t('activeDetails.province')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
      {selectedRow.company_address_details.community_province}</CustomText>  </Box>
            
                      <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
   {t('activeDetails.city')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
   {selectedRow.company_address_details.city}</CustomText>  </Box>

         <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
 {t('activeDetails.street')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right"  }}>
    {selectedRow.company_address_details.street_address}</CustomText>  </Box>
          
          </Box>

                   <Box sx={{
          
            mt:2,
         }}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 18, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
        {t('activeDetails.subscriptionDetails')}
          </CustomText>
                <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
        {t('activeDetails.subscriptionStatus')}</CustomText>
  
                      <Box sx={{ pointerEvents: "none" }}>
      <StatusDropdown
      currentStatus={selectedRow.account_details.subscription_status || "trial"}
      />
    </Box>
            
             </Box>
                   <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('activeDetails.subscription')}</CustomText>
     {/* <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
    {Array.isArray(selectedRow.subscription_details.subscription)
    ? selectedRow.subscription_details.subscription.join(", ")
    : String(selectedRow.subscription_details.subscription).replace(/[\[\]{}"]/g, "")}</CustomText> */}
    <CustomText 
  sx={{ 
    ...textStyles.h1, 
    fontSize: 15, 
    fontWeight: 400, 
    color: "#172B4D", 
textAlign:"right"  
  }}
>
  {Array.isArray(selectedRow.subscription_details.subscription)
    ? selectedRow.subscription_details.subscription
        .map(formatSubscription)
        .join(", ")
    : formatSubscription(selectedRow.subscription_details.subscription)}
</CustomText>
      </Box>

 
       <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
   {t("InviteDetails.maxUsers")}</CustomText>
      <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
  {selectedRow.subscription_details.max_users}</CustomText>  </Box>

      <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('activeDetails.duration')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow.subscription_details.duration}</CustomText>  </Box>
           
                <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('activeDetails.activationDate')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right"  }}>
{formatDateTime(selectedRow.subscription_details.activation_date)}
</CustomText>  </Box>


           

       <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('activeDetails.expiry')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{formatDateTime(selectedRow.subscription_details.expiry)}</CustomText>  </Box>
          
     
    
         
          </Box>

     



        
        </Box>
      </Box>
      <Box>
               
        <ActiveDetailsTable companyId={selectedRow?.raw_data?.company_id} companyAdminId={selectedRow?.account_details?.id}/>
        </Box>
 
    </>
  );
};

export default ActiveDetails;

